import { defineComponent, reactive, watch, ref, computed } from 'vue';
import { useStore } from 'vuex';
import _ from 'lodash';
import IconButton from '@hems/component/src/mapper/button/IconButton.vue';
import PhysicalCanvasCore from '@hems/component/src/mapper/canvas/PhysicalCanvasCore.vue';
import MapperTooltip from '@hems/component/src/mapper/tooltip/MapperTooltip.vue';
import MobileSelector from '@hems/component/src/smartmodule/gen2/MobileSelector.vue';
import MobileTimeLine from '@hems/component/src/smartmodule/gen2/timeline/MobileTimeLine.vue';
import { FabricHelperPro, Helper } from '@hems/util';
import { MAPPER_BUTTON_TYPE, MAPPER_PERIOD_DATA, MAPPER_POWER_DEFAULT_VALUE, MAPPER_APP_TYPE, } from '@hems/util/src/constant/mapper';
import { getColorPhaseRangeArray } from '@hems/util/src/helper/mapper/fabricHelperPro';
export default defineComponent({
    name: 'PhysicalCanvasHome',
    components: {
        IconButton,
        PhysicalCanvasCore,
        MapperTooltip,
        MobileTimeLine,
        MobileSelector,
    },
    props: {
        data: {
            type: String,
            default: '',
        },
        width: {
            type: Number,
            default: 0,
        },
        height: {
            type: Number,
            default: 0,
        },
        moduleDayPwData: {
            type: Array,
            required: true,
        },
        selectedDate: {
            type: String,
            required: true,
        },
        byDate: {
            type: String,
            required: true,
        },
        module15minPwData: {
            type: Array,
            required: true,
        },
        totalPowerValue: {
            type: Object,
            default: () => MAPPER_POWER_DEFAULT_VALUE,
        },
        moduleInfoData: {
            type: Object,
            required: true,
        },
    },
    emits: ['select', 'openCalendar', 'changeDateMode'],
    setup(props, { emit }) {
        const store = useStore();
        const canvas = ref(null);
        const isShowTooltip = ref(false);
        const showDropdown = ref(false);
        const activeSerial = ref('');
        const inverterSerial = ref('');
        const sliderTimeValue = ref('');
        const state = reactive({
            moduleDataListByCurrentSliderTime: [],
            dateType: props.byDate,
        });
        const groupedTimelineData = computed(() => _.chain(props.module15minPwData)
            .groupBy('colec_dt')
            .map((value, key) => ({
            colec_dt: FabricHelperPro.convertHourToMin(key),
            module_15min_pw_data_total: value.reduce((accumulator, moduleInfo) => accumulator + FabricHelperPro.roundDownEnergyToSecondDecimalPlaces(moduleInfo.watt), 0),
        }))
            .value());
        const colorCodeArray = ref(getColorPhaseRangeArray(state.dateType, props.selectedDate));
        const getColorCodeByActiveModule = () => {
            let modulePower;
            if (state.dateType === MAPPER_PERIOD_DATA.TIMELINE) {
                modulePower =
                    FabricHelperPro.getPowerValue(state.moduleDataListByCurrentSliderTime, inverterSerial.value) ?? -1;
            }
            else {
                modulePower = FabricHelperPro.getPowerValue(props.moduleDayPwData, inverterSerial.value) ?? -1;
            }
            const colorIndex = FabricHelperPro.classifyValueToColorIndex(modulePower, colorCodeArray.value);
            return colorIndex;
        };
        function openTooltip(acSerial, miSerial) {
            activeSerial.value = acSerial;
            inverterSerial.value = miSerial;
            showDropdown.value = false;
        }
        function onClick(event) {
            canvas.value?.processButtonEvent(event);
        }
        function changeToTimeline(timeValue) {
            state.dateType = MAPPER_PERIOD_DATA.TIMELINE;
            sliderTimeValue.value = timeValue;
        }
        function changeToDay() {
            state.dateType = MAPPER_PERIOD_DATA.DAY;
            emit('changeDateMode', state.dateType);
        }
        function changeDateMode(value) {
            state.dateType = value;
            emit('changeDateMode', state.dateType);
        }
        const getModuleDataListByCurrentSliderTime = () => {
            if (state.dateType !== MAPPER_PERIOD_DATA.TIMELINE) {
                return props.moduleDayPwData;
            }
            const moduleDataByCurrentTime = props.module15minPwData?.filter((moduleData) => {
                const minUnitValue = FabricHelperPro.convertHourToMin(String(moduleData.colec_dt));
                if (minUnitValue === Number(sliderTimeValue.value))
                    return moduleData;
            });
            const resultData = moduleDataByCurrentTime?.map((moduleData) => {
                return {
                    device_id: moduleData.device_id,
                    total_power: moduleData.watt,
                };
            });
            return resultData;
        };
        watch(() => [state.dateType, sliderTimeValue.value], () => {
            state.moduleDataListByCurrentSliderTime = getModuleDataListByCurrentSliderTime();
            colorCodeArray.value = getColorPhaseRangeArray(state.dateType, props.selectedDate);
        });
        watch(() => inverterSerial.value, (inverterSerial) => {
            isShowTooltip.value = !Helper.isNull(inverterSerial);
        });
        return {
            state,
            store,
            canvas,
            onClick,
            openTooltip,
            changeToTimeline,
            changeToDay,
            changeDateMode,
            getColorCodeByActiveModule,
            colorCodeArray,
            groupedTimelineData,
            isShowTooltip,
            activeSerial,
            inverterSerial,
            MAPPER_APP_TYPE,
            MAPPER_BUTTON_TYPE,
        };
    },
});
